/** Shared UI toggle state — read by ShipSprite, written by UIScene. */
export const uiState = {
  showEnemyOverlay: true,
};
